import {Component, OnDestroy, OnInit, input} from '@angular/core';

@Component({
    selector: 'app-countdown',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss'],
    standalone: false
})
export class CountdownComponent implements OnInit, OnDestroy {

  readonly startCounter = input<number>(undefined);
  hour: number;
  minute: number;
  second: number;
  distance: number;
  calculateInterval: number;

  constructor() {
    this.distance = 0;
    this.hour = 0;
    this.second = 0;
    this.minute = 0;
  }

  ngOnInit() {
    this.calculateCounter();
  }

  calculateCounter() {
    this.calculateInterval = setInterval(() => {
      this.distance += 1;
      this.hour = parseInt((this.startCounter() / 3600).toString());
      this.minute = parseInt(((this.startCounter() - 3600 * this.hour) / 60).toString());
      this.second = this.startCounter() - 3600 * this.hour - 60 * this.minute;
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.calculateInterval);
  }

}
